<template>
    <a target="_blank" href="https://www.legitscript.com/websites/?checker_keywords=getsmartrx.com">
        <img alt="Legit Scripts Badge verifying Site" style="width: auto; height: 6rem;" src="https://static.legitscript.com/seals/15905680.png">
    </a>
    <a href="https://safe.pharmacy/buy-safely/?url=www.getsmartrx.com" target="_blank" rel="noopener noreferrer" class="image-padding">
	<img alt="Safe Pharmacy Logo" loading="lazy" style="width: auto; height: 2rem;" src="/images/dot-pharmacy.png">
    </a>
</template>
<style>
  .image-padding {
    padding-left: 20px;
  }
</style>
<script>
</script>
